module.exports = __webpack_public_path__ + "img/AND臺灣藝術與科技中心.7b5be299.png";